"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableCells = void 0;
const boolean_cell_1 = require("./cells/boolean-cell");
const date_cell_1 = require("./cells/date-cell");
const date_time_cell_1 = require("./cells/date-time-cell");
const dictionary_column_mapper_1 = require("./cells/dictionary-column-mapper");
const number_cell_1 = require("./cells/number-cell");
const select_column_mapper_1 = require("./cells/select-column-mapper");
const text_cell_1 = require("./cells/text-cell");
const time_cell_1 = require("./cells/time-cell");
exports.TableCells = {
    BooleanCell: boolean_cell_1.BooleanCell,
    TextCell: text_cell_1.TextCell,
    NumberCell: number_cell_1.NumberCell,
    DateCell: date_cell_1.DateCell,
    DateTimeCell: date_time_cell_1.DateTimeCell,
    TimeCell: time_cell_1.TimeCell,
    ShortTimeCell: time_cell_1.ShortTimeCell,
    timeCellFactory: time_cell_1.timeCellFactory,
    useSelectCellFactory: select_column_mapper_1.useSelectCellFactory,
    dictionaryColumnMapper: dictionary_column_mapper_1.dictionaryColumnMapper,
    dictionaryArrayColumnMapper: dictionary_column_mapper_1.dictionaryArrayColumnMapper,
};
//# sourceMappingURL=table-cells.js.map